import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

type NavItem = {
  label: string;
  href: string;
};

const NAV_ITEMS: NavItem[] = [
  { label: "Über mich", href: "/" },
  // { label: "Articles", href: "/articles" },
  // { label: "Projects", href: "/projects" },
  // { label: "Speaking", href: "/speaking" },
  // { label: "Uses", href: "/uses" },
];

type NavLinkProps = {
  item: NavItem;
};

function NavLink({ item }: NavLinkProps) {
  const { pathname } = useLocation();
  const isActive = pathname === item.href;

  return (
    <li className="relative">
      <Link
        to={item.href}
        className={[
          "relative block px-3 py-2 transition",
          isActive
            ? "text-teal-500 dark:text-teal-400"
            : "hover:text-teal-500 dark:hover:text-teal-400",
        ].join(" ")}
      >
        {item.label}
        {isActive && (
          <span className="absolute inset-x-1 -bottom-px h-px bg-linear-to-r from-teal-500/0 via-teal-500/40 to-teal-500/0 dark:from-teal-400/0 dark:via-teal-400/40 dark:to-teal-400/0" />
        )}
      </Link>
    </li>
  );
}

export default function NavBar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex flex-1 mt-6 justify-end md:justify-center relative">
      {/* Mobile menu button */}
      <div className="pointer-events-auto md:hidden">
        <button
          type="button"
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen((prev) => !prev)}
          className="group flex items-center rounded-full bg-white/90 px-4 py-2 text-sm font-medium text-zinc-800 shadow-lg ring-1 shadow-zinc-800/5 ring-zinc-900/5 backdrop-blur-sm dark:bg-zinc-800/90 dark:text-zinc-200 dark:ring-white/10 dark:hover:ring-white/20"
        >
          Menu
          <svg
            viewBox="0 0 8 6"
            aria-hidden="true"
            className={[
              "ml-3 h-auto w-2 stroke-zinc-500 transition-transform group-hover:stroke-zinc-700 dark:group-hover:stroke-zinc-400",
              mobileOpen ? "rotate-180" : "",
            ].join(" ")}
          >
            <path
              d="M1.75 1.75 4 4.25l2.25-2.5"
              fill="none"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {/* Mobile dropdown */}
        {mobileOpen && (
          <div className="absolute right-0 w-1/6 top-full mt-2 mx-4">
            <nav className="rounded-2xl bg-white/90 p-2 shadow-lg ring-1 shadow-zinc-800/5 ring-zinc-900/5 backdrop-blur-sm dark:bg-zinc-800/90 dark:ring-white/10">
              <ul className="flex flex-col text-center text-sm font-medium text-zinc-800 dark:text-zinc-200">
                {NAV_ITEMS.map((item) => (
                  <NavLink key={item.href} item={item} />
                ))}
              </ul>
            </nav>
          </div>
        )}
      </div>

      {/* Desktop nav */}
      <nav className="pointer-events-auto hidden md:block">
        <ul className="flex rounded-full bg-white/90 px-3 text-sm font-medium text-zinc-800 shadow-lg ring-1 shadow-zinc-800/5 ring-zinc-900/5 backdrop-blur-sm dark:bg-zinc-800/90 dark:text-zinc-200 dark:ring-white/10">
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.href} item={item} />
          ))}
        </ul>
      </nav>
    </div>
  );
}